var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.295 3.842a8.325 8.325 0 0 1 3.41-.002 3.328 3.328 0 0 0 3.044 2.823c.499.037 1-.038 1.466-.22a8.324 8.324 0 0 1 1.702 2.954A3.328 3.328 0 0 0 18.667 12c0 1.053.488 1.992 1.252 2.603a8.368 8.368 0 0 1-1.705 2.953 3.329 3.329 0 0 0-4.509 2.6 8.326 8.326 0 0 1-3.409.004 3.327 3.327 0 0 0-3.045-2.825c-.498-.037-1 .038-1.465.22a8.324 8.324 0 0 1-1.702-2.954 3.327 3.327 0 0 0 1.25-2.602 3.328 3.328 0 0 0-1.252-2.603 8.37 8.37 0 0 1 1.705-2.953A3.328 3.328 0 0 0 9.753 5.22c.282-.413.467-.883.542-1.377v-.001ZM12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#7F8286"
  })));
};
export default SvgSettings;